<div
  class="loading-overlay"
  [class.loading-overlay--exit]="fadeOut()"
  role="status"
  [attr.aria-label]="'Cargando ' + title()"
>
  <app-prosell-logo mode="loading" tone="dark" class="w-56" />

  <div class="progress-bar" aria-hidden="true">
    <div class="progress-bar__fill"></div>
  </div>
</div>
